import { gql } from 'apollo-angular';

export const RemoveAssetFromActivityDocument =
  gql(/* GraphQL*/ `mutation removeAssetFromActivity($activityAssetId: Int!) {
  removeAssetFromActivity(activityAssetId: $activityAssetId)
}
`);
